export default __webpack_public_path__ + "static/media/Group_12090@2x.094fb649.svg";